import { render, staticRenderFns } from "./AccountAssetLoaded.vue?vue&type=template&id=ae6bb480&"
import script from "./AccountAssetLoaded.vue?vue&type=script&lang=ts&"
export * from "./AccountAssetLoaded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports